export default __webpack_public_path__ + "media/images/mailer-new/heading/boost-950a54c3c22406b51a61f817a409c414.png";